import paths from 'constants/paths';
const { allArticlesPage, categoryHome } = paths;

export const navigationItems = [
  { href: paths.basePath, text: 'Home', submenu: [] },
  {
    href: '',
    text: 'App Picks',
    submenu: [
      {
        href: categoryHome('app-picks'),
        text: 'All Articles',
      },
      {
        href: allArticlesPage('best-apps'),
        text: 'Best Apps',
      },
      {
        href: allArticlesPage('app-of-the-day'),
        text: 'App of the day',
      },
      {
        href: allArticlesPage('app-comparisons'),
        text: 'App comparisons',
      },
    ],
  },
  {
    href: '',
    text: 'Automation with Zapier',
    submenu: [
      {
        href: categoryHome('zapier-automation'),
        text: 'All Articles',
      },
      {
        href: allArticlesPage('automation-inspiration'),
        text: 'Automation inspiration',
      },
      {
        href: allArticlesPage('zapier-tutorials'),
        text: 'Zapier tutorials',
      },
      {
        href: allArticlesPage('customers'),
        text: 'Customer stories',
      },
    ],
  },
  {
    href: '',
    text: 'Productivity',
    submenu: [
      {
        href: categoryHome('productivity'),
        text: 'All Articles',
      },
      {
        href: allArticlesPage('productivity-tips'),
        text: 'Productivity tips',
      },
      {
        href: allArticlesPage('app-tips'),
        text: 'App tips',
      },
      {
        href: allArticlesPage('app-tutorials'),
        text: 'App tutorials',
      },
    ],
  },
  {
    href: '',
    text: 'Grow your business',
    submenu: [
      {
        href: categoryHome('grow-your-business'),
        text: 'All Articles',
      },
      {
        href: allArticlesPage('small-business-tips'),
        text: 'Small business tips',
      },
    ],
  },
  {
    href: '',
    text: 'Remote work',
    submenu: [
      {
        href: categoryHome('remote-work'),
        text: 'All Articles',
      },
      {
        href: allArticlesPage('remote-work-tips'),
        text: 'Remote work tips',
      },
      {
        href: allArticlesPage('how-we-work-at-zapier'),
        text: 'How we work at Zapier',
      },
    ],
  },
  {
    href: '/learn',
    text: 'Learning Center',
    submenu: [],
  },
  {
    href: '/blog/updates',
    text: 'Zapier Updates',
    submenu: [],
  },
];
